
import { config, debug, george, i18n, inject, observable, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { LandingPage } from "components/common/LandingPage";
import { NewAddress } from "components/common/NewAddress";
import * as _ from "lodash";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import trackingStore from "stores/TrackingStore";
import { NavigationBar } from "../common/NavigationBar";
import { NewPhone } from "../common/NewPhone";
import { CreditCardBusinessStore } from "./CreditCardBusinessStore";
import { ShopCreditCardBusinessCardInfo } from "./ShopCreditCardBusinessCardInfo";
import { ShopCreditCardBusinessPersonalData } from "./ShopCreditCardBusinessPersonalData";
import { ShopCreditCardBusinessRoutes } from "./ShopCreditCardBusinessRoutes";
import { ShopCreditCardBusinessSigning } from "./ShopCreditCardBusinessSigning";
import { ShopCreditCardBusinessSuccess } from "./ShopCreditCardBusinessSuccess";
import { ShopCreditCardBusinessSummary } from "./ShopCreditCardBusinessSummary";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class ShopCreditCardBusinessContainer extends React.Component<IProps, {}> {
    shopStore: CreditCardBusinessStore;

    @observable isInitialLoadComplete = false;

    constructor(props: any) {
        super(props);
        this.shopStore = new CreditCardBusinessStore();
    }

    async componentDidMount() {
        document.title = ui.__("creditCard.document.title");

        const channelProduct = this.props.externalInterfaceStore.channelProduct;
        const isMilesAndMoreCard = channelProduct === "MASTERSMAB_MM" || channelProduct === "MASTERPREB_MM";

        if (!isMilesAndMoreCard) {
            pushRoute(ShopCreditCardBusinessRoutes.ROOT);
        }

        try {
            if (auth.authorized) {
                if (this.props.externalInterfaceStore.productId &&
                    this.props.externalInterfaceStore.conditionsGroupId &&
                    this.props.externalInterfaceStore.channelProduct) {

                    await this.shopStore.load(this.props.externalInterfaceStore.productId,
                        this.props.externalInterfaceStore.conditionsGroupId,
                        this.props.externalInterfaceStore.channelProduct);


                    if (isMilesAndMoreCard) {

                        this.shopStore.accountsStore.selectedAccount = undefined;
                        this.shopStore.contactsStore.selectedAddressId = undefined;

                        this.isInitialLoadComplete = true;

                        pushRoute(ShopCreditCardBusinessRoutes.PERSONAL_DATA);
                    }
                    return;
                }
            }
            debug.log("### ShopCreditCardBusiness could not load store data");
        } catch (error) {
            debug.log("### ShopCreditCardBusiness.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withShopStore(Component: any) {
        return () => <Component {...this.props} store={this.shopStore} />;
    }

    withContactsStore(Component: any) {
        return () => <Component {...this.props} contactsStore={this.shopStore.contactsStore} />;
    }

    render() {
        const channelProduct = this.props.externalInterfaceStore.channelProduct;
        const isMilesAndMoreCard = channelProduct === "MASTERSMAB_MM" || channelProduct === "MASTERPREB_MM";

        // _,compact gets rid of account undefined entry if there is only one account
        const entries = _.compact([{
            path: "personal-data",
            title: ui.__("navbar.personalData.title")
        },
        {
            path: "card-info",
            title: ui.__("navbar.cardInfo.title")
        },
        {
            path: "summary",
            title: ui.__("navbar.summary.title")
        }]);

        if (isMilesAndMoreCard && !this.isInitialLoadComplete) {
            return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
        }

        return (
            <div>
                <NavigationBar basePath={ShopCreditCardBusinessRoutes.ROOT} pages={entries} path={this.props.location.pathname} backToBase />

                <Route
                    exact
                    path={ShopCreditCardBusinessRoutes.ROOT}
                    render={() => {

                        if (isMilesAndMoreCard) {
                            pushRoute(ShopCreditCardBusinessRoutes.PERSONAL_DATA);
                            return null;
                        }

                        return (
                            <LandingPage
                                useWebVersion
                                type="PRODUCT"
                                code={channelProduct}
                                store={this.shopStore}
                                onClickButton={async () => {
                                    await trackingStore.trackEvent({ eventName: "orderNow" });
                                    pushRoute(ShopCreditCardBusinessRoutes.PERSONAL_DATA);
                                }}
                            />
                        );
                    }}
                />
                <Route path={ShopCreditCardBusinessRoutes.PERSONAL_DATA} render={this.withShopStore(ShopCreditCardBusinessPersonalData)} />
                <Route path={ShopCreditCardBusinessRoutes.CARD_INFO} render={this.withShopStore(ShopCreditCardBusinessCardInfo)} />
                <Route path={ShopCreditCardBusinessRoutes.SUMMARY} render={this.withShopStore(ShopCreditCardBusinessSummary)} />
                <Route path={ShopCreditCardBusinessRoutes.SIGNING} render={this.withShopStore(ShopCreditCardBusinessSigning)} />
                <Route path={ShopCreditCardBusinessRoutes.SUCCESS} render={this.withShopStore(ShopCreditCardBusinessSuccess)} />
                <Route path={ShopCreditCardBusinessRoutes.NEW_PHONE} component={this.withContactsStore(NewPhone)} />
                <Route path={ShopCreditCardBusinessRoutes.NEW_ADDRESS} component={this.withContactsStore(NewAddress)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/ShopCreditCardBusinessContainer.tsx